import { render, staticRenderFns } from "./PackUpsell.vue?vue&type=template&id=07fbb56e&scoped=true"
import script from "./PackUpsell.vue?vue&type=script&lang=js"
export * from "./PackUpsell.vue?vue&type=script&lang=js"
import style0 from "./PackUpsell.vue?vue&type=style&index=0&id=07fbb56e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbb56e",
  null
  
)

export default component.exports